import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ResultOperation, Column, SelfTableList, FilterState, ListFields, usePermission, useTranslation } from '@np/np_webcomponentlib'
import { API_OPERATIONS } from '../../shared/consts/api'

import { DataEntityType, initEntity, columnsForChoose, DataEntityTypeViewModel } from './DHInterationTypes'



import { ColumnEvent, ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'

import '../../shared/entityOperations/EntityOperations.css'
import { DisplayStatusDoc } from '../Operation/OperationTypes';
import { typePaymentMethodLabels } from '../../shared/MasterData/MasterDataTypes';




const DHInterationList = ({ listFilterFieldProps }: { listFilterFieldProps: ListFields[] }) => {

  const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('SpecificationcharacteristictypeList');

  const initialFilter: FilterState = {
    listFields: listFilterFieldProps,
    sort: { fieldName: 'dateAdded', direction: 'asc' },
    searchData: '',
    take: 50,
    skip: 0,
  }



  const [forceUpdate, setForceUpdate] = useState<boolean>(false)


  const dateAddedTitle = useTranslation('dateAdded');
  const dateUpdatedTitle = useTranslation('dateUpdated');


  const memoizedColumnsRate = useCallback(() => {
    const columnsSpecificationcharacteristictype: Column[] = [

      

      {
        title: '',
        listFields: null,
        type: 'custom',
        custom: (data: DataEntityType) => (

          <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
        ),
        key: 1,
        withFilter: null,
        class: "eventColumn"
      },



      {
        title: dateAddedTitle,
        listFields: {
          fieldName: 'dateAdded',
          comparison: 'containsStrong',
          listVal: [''],
        },
        type: 'date-time',
        key: 100,
        withFilter: 'onlySorted',
        class: "dateTtimeColumn"
      },


      {
        title: "Провайдер",
        listFields: {
          fieldName: 'business',
          comparison: 'containsIgnoreCase',
          listVal: [''],
        },
        key: 7,
        type: 'custom',
        custom: (data: DataEntityType) => <>{data.business?.name}</>,
        withFilter: null,
      },

      {
        title: "Продолжительность запроса",
        listFields: {
          fieldName: 'durationRequest',
          comparison: 'containsIgnoreCase',
          listVal: [''],
        },
        key: 8,
        type: 'custom',
        custom: (data: DataEntityType) => <>{data.durationRequest}</>,
        withFilter: null,
      },

      {
        title: "Тип платежа",
        listFields: {
          fieldName: 'typePaymentMethod',
          comparison: 'containsIgnoreCase',
          listVal: [''],
        },
        key: 9,
        type: 'custom',
        custom: (data: DataEntityType) => <>{data.typePaymentMethod ? typePaymentMethodLabels[data.typePaymentMethod] : ''}</>,
        withFilter: null,
      },

      {
        title: "Тип взаимодействия",
        listFields: {
          fieldName: 'typeInteraction',
          comparison: 'containsIgnoreCase',
          listVal: [''],
        },
        key: 10,
        type: 'custom',
        custom: (data: DataEntityType) => <>{data.typeInteraction}</>,
        withFilter: null,
      },
      

      //TypeInteraction
      //TypePaymentMethod

    //   {
    //     title: "Статус",
    //     listFields: {
    //       fieldName: 'status',
    //       comparison: 'containsIgnoreCase',
    //       listVal: [''],
    //     },
    //     key: 7,
    //     type: 'custom',
    //     custom: (data: DataEntityType) => <><DisplayStatusDoc statusDoc={data.status} providerID={data.idProvider}></DisplayStatusDoc></>,
    //     withFilter: 'all',
    //   },


      {
        title: 'Результат',
        listFields: {
            fieldName: 'responceJSON',
            comparison: 'containsIgnoreCase',
            listVal: [''],
        },
        key: 19,
        withFilter: 'all',
    },

    {
        title: 'Подробнее',
        listFields: {
            fieldName: 'errorMessage',
            comparison: 'containsIgnoreCase',
            listVal: [''],
        },
        key: 20,
        withFilter: 'all',
    },




    ]
  

    // if (debugMode || canRemove) {
    //   columnsSpecificationcharacteristictype.push(
    //     {
    //       title: '',
    //       listFields: null,
    //       type: 'custom',
    //       custom: (data: DataEntityType) => (

    //         <DeleteEntity idUnique={data.idUnique} apiPath={`${API_PRODUCT}/catalogproduct`} onResult={onResultRemove}></DeleteEntity>
    //       ),
    //       key: 102,
    //       withFilter: null,
    //       class: "eventColumn"
    //     })
    // }
    return columnsSpecificationcharacteristictype
  }, [dateAddedTitle, dateUpdatedTitle, debugMode, canRemove])



  useEffect(() => {
    if (forceUpdate) {
      setForceUpdate(false)
    }
  }, [forceUpdate])



  return (
    <Fragment>
      {listFilterFieldProps.length > 0 && <SelfTableList apiUrl={`${API_OPERATIONS}dhinteraction/list`} columns={memoizedColumnsRate()} classProp='table table-striped' theadClassProp='table' forceUpdate={forceUpdate} initialFilterState={initialFilter} />}
      {listFilterFieldProps.length == 0 && <SelfTableList apiUrl={`${API_OPERATIONS}dhinteraction/list`} columns={memoizedColumnsRate()} classProp='table table-striped' theadClassProp='table' forceUpdate={forceUpdate} />}
    </Fragment>
  )
}


export default DHInterationList